import { render, staticRenderFns } from "./monitorTab.vue?vue&type=template&id=3190f248&scoped=true"
import script from "./monitorTab.vue?vue&type=script&lang=js"
export * from "./monitorTab.vue?vue&type=script&lang=js"
import style0 from "./monitorTab.vue?vue&type=style&index=0&id=3190f248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190f248",
  null
  
)

export default component.exports